export default __webpack_public_path__ + "static/media/home-hotel-resort-img-03.35cf4e36.jpg";